// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2wJut","medium":"Modal_medium__yl_sN","small":"Modal_small__1uzhl"};